import { useEffect, useState, useMemo } from "react";
import styles from "./styles.module.scss";
import quoteData from "../../../.sourceflow/quote.json";
import LeftArrowBlackCircle from "@/assets/LeftArrowBlackCircle.svg";
import RightArrowBlackCircle from "@/assets/RightArrowBlackCircle.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // ✅ added
import "swiper/css";

export const Testimonials = ({ className = "", image, stats = [], handPickedTestimonials = [] }) => {
  const allQuotes = quoteData?.category_values || [];
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const filteredQuotes = useMemo(() => {
    if (!allQuotes.length) return [];
    if (!handPickedTestimonials.length) return allQuotes;
    return allQuotes.filter((quote) => handPickedTestimonials.includes(quote.id));
  }, [allQuotes, handPickedTestimonials]);

  useEffect(() => {
    setIndex(0);
  }, [filteredQuotes]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!filteredQuotes.length) return null;

  const next = () => setIndex((prev) => (prev + 1) % filteredQuotes.length);
  const prev = () => setIndex((prev) => (prev - 1 + filteredQuotes.length) % filteredQuotes.length);

  const current = filteredQuotes[index];
  const quote = current?.quote?.en || "";
  const author = current?.author?.en || "";
  const role = current?.role?.en || "";

  return (
    <section className={`${styles.wrapper} ${className}`}>
      <div className={styles.backgroundImage}>
        <img src={image?.url || "/images/testimonialgirl.jpg"} alt="" className={styles.image} />
        {stats.length > 0 && (
          <div className={styles.statsOverlay}>
            <div className={styles.statsGrid}>
              {stats.map((stat, i) => (
                <div className={styles.statBlock} key={i}>
                  <div className={styles.statNumber}>{stat.value}</div>
                  <div className={styles.statLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {isMobile ? (
        <Swiper
          slidesPerView={1}
          className={styles.mobileSwiper}
          modules={[Autoplay]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop={true}
          speed={700}
        >
          {filteredQuotes.map((q, idx) => (
            <SwiperSlide key={idx}>
              <div className={styles.content}>
                <div className={styles.quoteBox}>
                  <div className={styles.quoteMark}>"</div>
                  <div className={styles.quote} dangerouslySetInnerHTML={{ __html: q.quote?.en }} />
                </div>
                <div className={styles.authorBlock}>
                  <div className={styles.name} dangerouslySetInnerHTML={{ __html: q.author?.en }} />
                  <div className={styles.title} dangerouslySetInnerHTML={{ __html: q.role?.en }} />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className={styles.content}>
          <div className={styles.quoteBox}>
            <div className={styles.quoteMark}>"</div>
            <div className={styles.quote} dangerouslySetInnerHTML={{ __html: quote }} />
          </div>
          <div className={styles.authorBlock}>
            <div className={styles.name} dangerouslySetInnerHTML={{ __html: author }} />
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: role }} />
          </div>
          {filteredQuotes.length > 1 && (
  <div className={styles.arrows}>
    <button type="button" className={styles.arrowButton} onClick={prev} aria-label="Previous testimonial">
      <LeftArrowBlackCircle className={styles.arrowIcon} />
    </button>
    <button type="button" className={styles.arrowButton} onClick={next} aria-label="Next testimonial">
      <RightArrowBlackCircle className={styles.arrowIcon} />
    </button>
  </div>
)}
        </div>
      )}
    </section>
  );
};


export default Testimonials;
